import React from 'react';

import { getApplicableL2MyDataModules } from 'Deer/components/navigation/secondary/ModuleSection';
import { L2_PATHS, staticRoutes } from 'Deer/constants/routes';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';
// import { routes } from 'Deer/constants';
import PrivateRoute from 'components/PrivateRoute';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { Redirect, Route, Switch } from 'react-router-dom';
import KnowledgeHub from 'screens/admin/HelpCenter/KnowledgeHub';

import { PageNotFound404 } from '../PageNotFound404';
import { CheckIns } from './CheckIns';
import Develop from './Develop';
import { MyDataDisciplinaryActions } from './DisciplinaryActions';
import Engagement from './Engagement';
import Goals from './Goals';
import Initiatives from './Initiatives';
import OneOnOne from './OneOnOne';
import CompanyOneOnOneCalender from './OneOnOne/Calender';
import Overview from './Overview';
import Reviews from './Reviews';
import { NotificationsPage } from './Settings/Notifications';

const MyData = () => {
  const userL2Accesses = getUserL2Access();
  const {
    hasGoalAccess,
    hasFeedbackAccess,
    hasOneOnOneAccess,
    hasReviewAccess,
    hasInitiativeAccess,
    hasEngagementAccess,
    hasCheckInsAccess,
    hasDisciplinaryActionsAccess,
  } = userL2Accesses;

  const { moduleName } = useOrganisationSettings();

  const applicableL2MyDataModules = getApplicableL2MyDataModules(moduleName);

  return (
    <Switch>
      {hasCheckInsAccess ? <PrivateRoute path={L2_PATHS['my-data'].checkIns} component={CheckIns} /> : null}
      {hasGoalAccess ? <PrivateRoute path={L2_PATHS['my-data'].goal} component={Goals} /> : null}
      {hasReviewAccess ? <PrivateRoute path={L2_PATHS['my-data'].review} component={Reviews} /> : null}
      {hasOneOnOneAccess ? <PrivateRoute path={L2_PATHS['my-data'].oneOnOne} component={OneOnOne} /> : null}
      {hasFeedbackAccess ? <PrivateRoute path={L2_PATHS['my-data'].develop} component={Develop} /> : null}
      {hasInitiativeAccess ? <PrivateRoute path={L2_PATHS['my-data'].initiative} component={Initiatives} /> : null}
      {hasEngagementAccess ? <PrivateRoute path={L2_PATHS['my-data'].engagement} component={Engagement} /> : null}
      {hasDisciplinaryActionsAccess ? (
        <PrivateRoute path={L2_PATHS['my-data'].disciplinaryActions} component={MyDataDisciplinaryActions} />
      ) : null}
      <PrivateRoute path={L2_PATHS['my-data'].overview} component={Overview} />

      {/* non-module routes */}

      <PrivateRoute path={staticRoutes['my-data']['my-settings'].calendar} component={CompanyOneOnOneCalender} />
      <PrivateRoute path={staticRoutes['my-data']['my-settings'].notifications} component={NotificationsPage} />
      <PrivateRoute path={staticRoutes['my-data']['my-settings'].knowledgeHub} component={KnowledgeHub} />
      {/* Redirecting partial my data  paths to first applicable L2 path */}
      {applicableL2MyDataModules.length > 0 && (
        <PrivateRoute exact path="/app/my-data">
          <Redirect to={applicableL2MyDataModules[0].value} />
        </PrivateRoute>
      )}
      <Route path="*" component={PageNotFound404} />
    </Switch>
  );
};

export default MyData;
